import { Template } from './templates';
import adfTemplate0 from './templates/workshop-planner-blueprint';
import adfTemplate1 from './templates/working-agreements-blueprint';
import adfTemplate2 from './templates/work-trip-planner-blueprint';
import adfTemplate3 from './templates/recurring-meeting-minutes-blueprint';
import adfTemplate4 from './templates/voting-table-blueprint';
import adfTemplate5 from './templates/vision-to-values-blueprint';
import adfTemplate6 from './templates/writing-guideline-blueprint';
import adfTemplate7 from './templates/virtual-lunch-blueprint';
import adfTemplate8 from './templates/virtual-event-blueprint';
import adfTemplate9 from './templates/vendor-agreement-blueprint';
import adfTemplate10 from './templates/year-in-review-blueprint';
import adfTemplate11 from './templates/transition-plan-blueprint';
import adfTemplate12 from './templates/to-do-list-blueprint';
import adfTemplate13 from './templates/team-poster-blueprint';
import adfTemplate14 from './templates/team-homepage-blueprint';
import adfTemplate15 from './templates/ideal-workweek-blueprint';
import adfTemplate16 from './templates/swot-analysis-blueprint';
import adfTemplate17 from './templates/design-systems-blueprint';
import adfTemplate18 from './templates/business-strategy-blueprint';
import adfTemplate19 from './templates/startup-pitch-deck-blueprint';
import adfTemplate20 from './templates/stakeholder-communications-blueprint';
import adfTemplate21 from './templates/design-sprint-blueprint';
import adfTemplate22 from './templates/design-review-blueprint';
import adfTemplate23 from './templates/design-decision-blueprint';
import adfTemplate24 from './templates/design-component-blueprint';
import adfTemplate25 from './templates/dependency-mapping-blueprint';
import adfTemplate26 from './templates/daily-stand-up-blueprint';
import adfTemplate27 from './templates/customer-journey-mapping-blueprint';
import adfTemplate28 from './templates/brainstorming-with-remote-teams-blueprint';
import adfTemplate29 from './templates/customer-interview-report-blueprint';
import adfTemplate30 from './templates/customer-impact-assessment-blueprint';
import adfTemplate31 from './templates/creative-brief-blueprint';
import adfTemplate32 from './templates/content-strategy-blueprint';
import adfTemplate33 from './templates/content-design-glossary-blueprint';
import adfTemplate34 from './templates/competitive-analysis-blueprint';
import adfTemplate35 from './templates/change-management-plan-blueprint';
import adfTemplate36 from './templates/career-development-plan-blueprint';
import adfTemplate37 from './templates/business-status-update-blueprint';
import adfTemplate38 from './templates/out-of-office-plan-blueprint';
import adfTemplate39 from './templates/all-hands-meeting-blueprint';
import adfTemplate40 from './templates/business-plan-one-pager-blueprint';
import adfTemplate41 from './templates/sprint-planning-meeting-blueprint';
import adfTemplate42 from './templates/okr-blueprint';
import adfTemplate43 from './templates/sparring-blueprint';
import adfTemplate44 from './templates/software-architecture-review-blueprint';
import adfTemplate45 from './templates/smart-goals-blueprint';
import adfTemplate46 from './templates/service-team-health-monitor-blueprint';
import adfTemplate47 from './templates/sales-portal-template-blueprint';
import adfTemplate48 from './templates/account-planning-for-sales-blueprint';
import adfTemplate49 from './templates/safe-business-case-blueprint';
import adfTemplate50 from './templates/roles-responsibilities-blueprint';
import adfTemplate51 from './templates/ritual-reset-blueprint';
import adfTemplate52 from './templates/my-user-manual-blueprint';
import adfTemplate53 from './templates/mvp-ideation-blueprint';
import adfTemplate54 from './templates/mutual-action-plan-blueprint';
import adfTemplate55 from './templates/message-house-template-blueprint';
import adfTemplate56 from './templates/aws-architecture-diagram-blueprint';
import adfTemplate57 from './templates/meeting-notes-blueprint';
import adfTemplate58 from './templates/master-project-document-blueprint';
import adfTemplate59 from './templates/marketing-united-blueprint';
import adfTemplate60 from './templates/marketing-blueprint';
import adfTemplate61 from './templates/marketing-blog-post-blueprint';
import adfTemplate62 from './templates/leadership-team-health-monitor-blueprint';
import adfTemplate63 from './templates/job-offer-letter-blueprint';
import adfTemplate64 from './templates/job-description-blueprint';
import adfTemplate65 from './templates/it-project-poster-blueprint';
import adfTemplate66 from './templates/itsm-weekly-major-incident-report-blueprint';
import adfTemplate67 from './templates/itsm-runbook-blueprint';
import adfTemplate68 from './templates/itsm-pir-blueprint';
import adfTemplate69 from './templates/itsm-known-errors-blueprint';
import adfTemplate70 from './templates/itsm-change-management-blueprint';
import adfTemplate71 from './templates/introductory-blog-blueprint';
import adfTemplate72 from './templates/interview-feedback-blueprint';
import adfTemplate73 from './templates/incident-management-post-mortem-blueprint';
import adfTemplate74 from './templates/incident-communication-blueprint';
import adfTemplate75 from './templates/hr-knowledge-base-management-blueprint';
import adfTemplate76 from './templates/risk-assessment-blueprint';
import adfTemplate77 from './templates/retrospectives-blueprint';
import adfTemplate78 from './templates/remote-team-meeting-blueprint';
import adfTemplate79 from './templates/qtc-acquisition-blueprint';
import adfTemplate80 from './templates/quarterly-check-in-blueprint';
import adfTemplate81 from './templates/kb-how-to-article-blueprint';
import adfTemplate82 from './templates/hiring-process-blueprint';
import adfTemplate83 from './templates/project-team-health-monitor-blueprint';
import adfTemplate84 from './templates/project-status-blueprint';
import adfTemplate85 from './templates/pp-blueprint';
import adfTemplate86 from './templates/projectplan-blueprint';
import adfTemplate87 from './templates/project-kickoff-blueprint';
import adfTemplate88 from './templates/fundraising-database-blueprint';
import adfTemplate89 from './templates/product-roadmap-blueprint';
import adfTemplate90 from './templates/requirements-blueprint';
import adfTemplate91 from './templates/executive-business-review-blueprint';
import adfTemplate92 from './templates/productlaunch-blueprint';
import adfTemplate93 from './templates/problem-framing-blueprint';
import adfTemplate94 from './templates/prioritization-matrix-blueprint';
import adfTemplate95 from './templates/experiment-planning-and-results-blueprint';
import adfTemplate96 from './templates/eow-status-report-blueprint';
import adfTemplate97 from './templates/employee-promotion-letter-blueprint';
import adfTemplate98 from './templates/employee-handbook-blueprint';
import adfTemplate99 from './templates/email-drip-blueprint';
import adfTemplate100 from './templates/elevator-pitch-blueprint';
import adfTemplate101 from './templates/disrupt-brainstorming-blueprint';
import adfTemplate102 from './templates/devops-change-management-blueprint';
import adfTemplate103 from './templates/devops-runbook-blueprint';
import adfTemplate104 from './templates/presenter-mode-blueprint';
import adfTemplate105 from './templates/pre-mortem-blueprint';
import adfTemplate106 from './templates/persona-blueprint';
import adfTemplate107 from './templates/performance-improvement-plan-blueprint';
import adfTemplate108 from './templates/ooo-team-notification-blueprint';
import adfTemplate109 from './templates/90-day-plan-blueprint';
import adfTemplate110 from './templates/decisions-blueprint';
import adfTemplate111 from './templates/4-ls-retrospective-blueprint';
import adfTemplate112 from './templates/1-on-1-meeting-blueprint';
import adfTemplate113 from './templates/annual-plan-one-pager-blueprint';
import adfTemplate114 from './templates/5-whys-analysis-blueprint';

export const wacTemplates: Record<string, Template> = {
  'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-blueprint',
      name: 'Workshop planner',
      description:
        'Design your workshop ahead, outline key information, agenda items, and recording decisions.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6nHVltJwkrw6G2OIUpeFJy/eb3c9ead5a53f94f030a6cb8ebdee9b4/workshop-planner.svg',
      template: adfTemplate0,
      urlSlug: 'workshop-planner'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:working-agreements-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:working-agreements-blueprint',
      name: 'Working agreements',
      description:
        'Work as a team to develop working agreements using this template.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1rffpq7A35PTymPQeZfmid/f9e86c1005dff8a7f6ec142a4a9d774f/working-agreements.svg',
      template: adfTemplate1,
      urlSlug: 'working-agreements'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:work-trip-planner-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:work-trip-planner-blueprint',
      name: 'Work trip planner',
      description: 'Keep track of all of your work trip plans and activities.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4tTQ0H4LdeeKEDZf59SmQd/8cd94dca69c12126258f48f4191a6d21/work-trip-planner.svg',
      template: adfTemplate2,
      urlSlug: 'work-trip-planner'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint',
      name: 'Weekly meeting notes',
      description:
        'Run ongoing meetings efficiently, tracking action items and follow-ups from week to week',
      icon: '//images.ctfassets.net/xjcz23wx147q/5jYRRLwYirREO6HytE84pT/604f183b3cc0b5f1ecabd6ac143ff643/ongoing-meeting-notes.svg',
      template: adfTemplate3,
      urlSlug: 'weekly-meeting-notes'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:voting-table-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:voting-table-blueprint',
      name: 'Voting table',
      description:
        'Poll your team to prioritize tasks, agree on a strategy, or align on other key decisions to be made.',
      icon: '//images.ctfassets.net/xjcz23wx147q/JLDoMYWtE5NQJDOpJ3YIG/d8c93338585cf3c53f4bdbc27d9925bf/voting-table.svg',
      template: adfTemplate4,
      urlSlug: 'voting-table'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint',
      name: 'Vision to values',
      description:
        'Define your company vision so you can form actionable business strategies.',
      icon: '//images.ctfassets.net/xjcz23wx147q/7fLNSFfwYVAxsXn8N4VCai/15fc6e2c1be7c1643fa10d36353c4398/vision-to-values.svg',
      template: adfTemplate5,
      urlSlug: 'vision-to-values'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:writing-guideline-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:writing-guideline-blueprint',
      name: 'Writing guidelines',
      description:
        'Document your organization’s content design patterns and best practices',
      icon: '//images.ctfassets.net/xjcz23wx147q/3ISJnVflfZMmHRCkz7pgnY/540fd25cde43db4badf452a4fe924188/Screenshot_2024-01-22_at_3.42.30_PM.png',
      template: adfTemplate6,
      urlSlug: 'writing-guidelines'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-lunch-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-lunch-blueprint',
      name: 'Virtual team lunch',
      description:
        'Spend a lunch with your team no matter where you are working from.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2p9L5Qp0g6oy9qePNv1ykR/9b07b93821120f8c2d0d4ee0197df0f5/virtual-team-lunch.svg',
      template: adfTemplate7,
      urlSlug: 'virtual-team-lunch'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-event-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-event-blueprint',
      name: 'Virtual event',
      description:
        'Streamline your virtual event process by scheduling speakers for an online audience.',
      icon: '//images.ctfassets.net/xjcz23wx147q/46Z2uA40dkC727MNl3JwWL/3226f26d2a565cb616e87b3525405d38/virtual-event.svg',
      template: adfTemplate8,
      urlSlug: 'virtual-event'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
      name: 'Vendor agreement',
      description:
        'Legitimize vendor relationships with a contractual agreement.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4q7ghkMaIhgWZIPimHcSCQ/98690b48ab546d55fb6fa2a4087c3a89/vendor-agreemnt.svg',
      template: adfTemplate9,
      urlSlug: 'vendor-agreement'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:year-in-review-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:year-in-review-blueprint',
      name: 'Year in review',
      description:
        'Take some time to reflect and review highlights from this past year.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2x4C9DnLOAXH5dNtdY8abd/92b3b2697eccc6b706126d793b8384ef/Screenshot_2024-01-22_at_3.34.18_PM.png',
      template: adfTemplate10,
      urlSlug: 'year-in-review'
    },
  // 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint':
  //   {
  //     id: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
  //     name: 'Troubleshooting article ',
  //     description: 'Provide solutions for commonly encountered problems.',
  //     icon: '//images.ctfassets.net/xjcz23wx147q/4wDANPTridhV4dNEAiQ7jb/f8c58e7419b832796d542cebdb289cf3/troubleshooting-article.svg',
  //     template: require('./templates/kb-troubleshooting-article-blueprint')
  //       .default
  //   },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:transition-plan-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:transition-plan-blueprint',
      name: 'Transition plan',
      description:
        'Create a comprehensive transition plan to provide your successor with key details.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1uCWDiSQw84CeovVljeBkh/a175401ddc9a8b9961a6886596d8e3f0/transition-plan.svg',
      template: adfTemplate11,
      urlSlug: 'transition-plan'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
      name: 'To-do list',
      description: 'Track and update your to-dos.',
      icon: '//images.ctfassets.net/xjcz23wx147q/3LTKPl3vJzSOaqPjGbuLvx/47d529caac542d437176ad5282f668b9/to-do-list.svg',
      template: adfTemplate12,
      urlSlug: 'to-do-list'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-blueprint',
      name: 'Team Poster',
      description:
        'Get your team on the same page about what they should be working by creating a team poster.',
      icon: '//images.ctfassets.net/xjcz23wx147q/46jAAiIRg3a1mKqj1QNcSZ/d28bcaea4478d9df44e4137fdfa443f3/project-poster.svg',
      template: adfTemplate13,
      urlSlug: 'team-poster'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:team-homepage-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-homepage-blueprint',
      name: 'Team Homepage',
      description:
        'Create a homepage for your team’s space so others know who you are and what you’re working on.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2Zge9lqyTNEKRQGc5jAWqg/3c31b68f04bee9b48a42571cf55b76ef/team-homepage.svg',
      template: adfTemplate14,
      urlSlug: 'team-homepage'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:ideal-workweek-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:ideal-workweek-blueprint',
      name: 'Design your ideal workweek',
      description:
        'Identify priorities, set boundaries, and design an efficient workweek you feel good about.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1Xpiasokqq9hxV2BzFlbVk/b7fcd3bf8ad3638ce2ad213bd8593301/Screenshot_2024-01-22_at_2.44.39_PM.png',
      template: adfTemplate15,
      urlSlug: 'design-your-ideal-workweek'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint',
      name: 'SWOT analysis',
      description:
        'Use this template to assess how your business is performing and how it can improve.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4Q3IX86x1QaU2nWSwI5WIJ/6938d305f541a49666a9d6776b8da813/swot-analysis.svg',
      template: adfTemplate16,
      urlSlug: 'swot-analysis'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
      name: 'Design system',
      description:
        'Scale your design team by developing a unified design system – with help from the pros',
      icon: '//images.ctfassets.net/xjcz23wx147q/Z9MIHKlSViibA3j1yhR8X/627512bf75fe69c7cde951b77acdcce8/Screenshot_2024-01-22_at_1.26.13_PM.png',
      template: adfTemplate17,
      urlSlug: 'design-system'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
      name: 'Strategic plan',
      description:
        'Capture and present your business strategy to the executive team and board of directors.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2zGYT0BKy10XKLPS2m7YiJ/b54a2a6632f8a7fa1978cb43c097cf60/business-strategy.svg',
      template: adfTemplate18,
      urlSlug: 'strategic-plan'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:startup-pitch-deck-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:startup-pitch-deck-blueprint',
      name: 'Startup pitch deck',
      description:
        'Pitch interested parties on your startup ideas by telling your story.',
      icon: '//images.ctfassets.net/xjcz23wx147q/5GByMNNUIKamNJZfz5pPlF/594081672f47c6b6257bd30b7cf92681/start-up-pitch-deck.svg',
      template: adfTemplate19,
      urlSlug: 'startup-pitch-deck'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-blueprint',
      name: 'Stakeholder communications',
      description:
        'Create a plan to get stakeholders the right information at the right time.',
      icon: '//images.ctfassets.net/xjcz23wx147q/3aTRdr1HV63BI2XBXF2unP/753c05d8e1f7e8c5d19ad7ac16ccd95e/stakeholder-communications.svg',
      template: adfTemplate20,
      urlSlug: 'stakeholder-communications'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
      name: 'Design sprint',
      description:
        'Present design solutions and exchange creative feedback with your team',
      icon: '//images.ctfassets.net/xjcz23wx147q/1CCzipH5qHl2Br0caA9RuI/021d53992dd5e9d02b11e67dac785709/Screenshot_2024-01-22_at_1.55.33_PM.png',
      template: adfTemplate21,
      urlSlug: 'design-sprint'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
      name: 'Design review template',
      description: 'Document requirements and run a productive design review',
      icon: '//images.ctfassets.net/xjcz23wx147q/20eVF6wOVvjFy1ngJrb3e4/6fb2d97f3258083b74b41cca2c08868e/Screenshot_2024-01-22_at_1.46.42_PM.png',
      template: adfTemplate22,
      urlSlug: 'design-review'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
      name: 'Design decision',
      description:
        'Present design solutions and exchange creative feedback with your team',
      icon: '//images.ctfassets.net/xjcz23wx147q/Z9MIHKlSViibA3j1yhR8X/627512bf75fe69c7cde951b77acdcce8/Screenshot_2024-01-22_at_1.26.13_PM.png',
      template: adfTemplate23,
      urlSlug: 'design-decision'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:design-component-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-component-blueprint',
      name: 'Design component',
      description: 'Create a library of carefully documented design components',
      icon: '//images.ctfassets.net/xjcz23wx147q/6CaXHFHFA5yQbfjUvLbeU8/fcc0fe0d8259db2aa55949a1f592c6b5/Screenshot_2024-01-22_at_1.18.02_PM.png',
      template: adfTemplate24,
      urlSlug: 'design-component'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:dependency-mapping-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:dependency-mapping-blueprint',
      name: 'Dependency mapping',
      description:
        'Plan work effectively by understanding the dependencies required to make the project successful',
      icon: '//images.ctfassets.net/xjcz23wx147q/6imC6KQYpHjbmSJ1H0qM0n/6814860258d2563d0de4265c26fc0679/Screenshot_2024-01-22_at_1.11.15_PM.png',
      template: adfTemplate25,
      urlSlug: 'dependency-mapping'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:daily-stand-up-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:daily-stand-up-blueprint',
      name: 'Daily stand up',
      description: 'Keep your team updated on what everyone is doing each day.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6geqBkxoB3zWfhPS4NsMFf/25bdc0c17e20b33da84688b032aaa66b/Screenshot_2024-01-22_at_1.04.52_PM.png',
      template: adfTemplate26,
      urlSlug: 'daily-stand-up'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint',
      name: 'Customer journey mapping',
      description:
        'Visualize how customers experience your product or service, and how they feel along the way',
      icon: '//images.ctfassets.net/xjcz23wx147q/w0YGKUTvOZ8YLaxZEqVpP/cd333327d2ac6b4cf7e7265978499888/Screenshot_2024-01-22_at_10.16.51_AM.png',
      template: adfTemplate27,
      urlSlug: 'customer-journey-mapping'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
      name: 'Brainstorming',
      description:
        'Plan, run, and document a remote brainstorming session for your next great idea.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1mTFzsK9TDiS8gL4TAJx9o/03f171800ab204fd9d04196b3b9ebb71/Screenshot_2024-01-19_at_2.38.36_PM.png',
      template: adfTemplate28,
      urlSlug: 'brainstorming'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
      name: 'Customer interview report',
      description: 'Turn customer interviews into actionable intelligence',
      icon: '//images.ctfassets.net/xjcz23wx147q/4Wb7yoSumixp3Vv847WlOI/adde8d5bcf0c42d64024e2359f3584d6/Screenshot_2024-01-22_at_1.33.01_AM.png',
      template: adfTemplate29,
      urlSlug: 'customer-interview-report'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint',
      name: 'Customer impact assessment',
      description: 'Make a change with zero pain with the right process',
      icon: '//images.ctfassets.net/xjcz23wx147q/6C0hp1TJEPcVshTcpXgmTf/6c7b754015d105007c492db6c1ff9a35/Screenshot_2024-01-22_at_1.23.32_AM.png',
      template: adfTemplate30,
      urlSlug: 'customer-impact-assessment'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:creative-brief-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:creative-brief-blueprint',
      name: 'Creative brief',
      description: 'Lock in your vision and bring it to life',
      icon: '//images.ctfassets.net/xjcz23wx147q/5O3IzCW9XM3dByKvaEJIM4/694f4adc9025955d37458b692049dee5/Screenshot_2024-01-22_at_1.11.20_AM.png',
      template: adfTemplate31,
      urlSlug: 'creative-brief'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-blueprint',
      name: 'Content strategy',
      description:
        'Map out your content strategy and organize your editorial calendar',
      icon: '//images.ctfassets.net/xjcz23wx147q/4Tl56lcTZpReJrgbCZMSRw/012209d4c6af2d7fbba9c860c2e16da2/Screenshot_2024-01-22_at_1.04.27_AM.png',
      template: adfTemplate32,
      urlSlug: 'content-strategy'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:content-design-glossary-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-design-glossary-blueprint',
      name: 'Content design glossary',
      description:
        'Create an A-Z guide to help your team design effective content',
      icon: '//images.ctfassets.net/xjcz23wx147q/5xC6UfUOXWleGZEM1nh7f0/1176863ac37bb237af13dac4a3eb0c46/Screenshot_2024-01-22_at_1.00.05_AM.png',
      template: adfTemplate33,
      urlSlug: 'content-design-glossary'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint',
      name: 'Competitive analysis',
      description: 'Discover how you can stand out',
      icon: '//images.ctfassets.net/xjcz23wx147q/RepWlgNp7k55XBLBsPlCR/e21bd566223457246eec8b8e2ac82d85/Screenshot_2024-01-22_at_12.52.33_AM.png',
      template: adfTemplate34,
      urlSlug: 'competitive-analysis'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:change-management-plan-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:change-management-plan-blueprint',
      name: 'Change management plan',
      description:
        'Create a plan for change that lays out the details and action',
      icon: '//images.ctfassets.net/xjcz23wx147q/6yzoOQ4hFLbFXDcT5vwWr3/d3ead8d590af2800ea58ef9284a3f093/Screenshot_2024-01-22_at_12.45.14_AM.png',
      template: adfTemplate35,
      urlSlug: 'change-management-plan'
    },
  // 'com.atlassian.confluence.plugins.confluence-business-blueprints:capacity-planning-blueprint':
  //   {
  //     id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:capacity-planning-blueprint',
  //     name: 'Capacity planning template',
  //     description: 'Get real about your team’s bandwidth',
  //     icon: '//images.ctfassets.net/xjcz23wx147q/3Y7xvebONdosNnKZDAgtze/f9d3960177d70d15cda193bb8c263bf1/Screenshot_2024-01-22_at_12.36.40_AM.png',
  //     template: require('./templates/capacity-planning-blueprint').default
  //   },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint',
      name: 'Career development plan',
      description: 'Jump start your career and achieve your professional goals',
      icon: '//images.ctfassets.net/xjcz23wx147q/67V7VREJyOoup6jCNv6snJ/60a44c379d3001729f03c1da0cbb2bed/Screenshot_2024-01-22_at_12.26.01_AM.png',
      template: adfTemplate36,
      urlSlug: 'career-development-plan'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
      name: 'Business status update template',
      description:
        'Share performance results and customer insights with stakeholders',
      icon: '//images.ctfassets.net/xjcz23wx147q/2U7SSMITNgkTecCshsywlr/5065c5648eca0eb244f07eb99c6fd8e2/Screenshot_2024-01-22_at_12.13.21_AM.png',
      template: adfTemplate37,
      urlSlug: 'business-status-update'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:out-of-office-plan-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:out-of-office-plan-blueprint',
      name: 'Out of office plan',
      description: 'Ensure continuity of your work while you’re out of office.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6VzNJx7815PAa9flPTVpoi/a9f60129e6d15378723ac7b72faa32bd/out-of-office-plan.svg',
      template: adfTemplate38,
      urlSlug: 'out-of-office-plan'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
      name: 'All hands meeting template',
      description:
        'Share business updates, victories, employee spotlights, and more with your larger team.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1KdokwuuPTOEas2730hpme/db26aef54959a1ff365a6ce6fbe0b81c/Screenshot_2024-01-19_at_11.25.09_AM.png',
      template: adfTemplate39,
      urlSlug: 'all-hands-meeting'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint',
      name: 'Business plan one-pager',
      description:
        'Set your strategy (and stick to it) with a short and simple plan',
      icon: '//images.ctfassets.net/xjcz23wx147q/7uAQU735cmwwTvMzBtYr89/6d5d418c1805d572af18007f17987132/Screenshot_2024-01-19_at_3.08.00_PM.png',
      template: adfTemplate40,
      urlSlug: 'business-plan-one-pager'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
      name: 'Sprint planning meeting',
      description: 'Organize and run your sprint planning meetings with ease.',
      icon: '//images.ctfassets.net/xjcz23wx147q/gu3G0Lx0xYFPw9yKJmI7l/03d9f9524da76cf4bbb87b6e5bc0ecf8/sprint-planning-meeting.svg',
      template: adfTemplate41,
      urlSlug: 'sprint-planning-meeting'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
      name: 'OKRs',
      description:
        'Use this goal-setting template to set measurable, ambitious milestones.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2z7T8w84kkcMGEdiJdH8Ui/b0940bc8f7de32a9bd3d0d822cc8facb/okrs.svg',
      template: adfTemplate42,
      urlSlug: 'okrs'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:sparring-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sparring-blueprint',
      name: 'Sparring',
      description: 'Lead sparring sessions and gather feedback from your team.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2G8ky6lfu66DgZqaEAVIGX/fb929ceb017258b05fb9e3fb5566b105/sparring.svg',
      template: adfTemplate43,
      urlSlug: 'sparring'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
      name: 'Software architecture review',
      description:
        'Collect information, loop in stakeholders, and kick off your software architecture review.',
      icon: '//images.ctfassets.net/xjcz23wx147q/YHSDZOTZaynpOYyUM0x5E/f5646db9e03f42e7ac117b10161c21c6/software-architecture-review.svg',
      template: adfTemplate44,
      urlSlug: 'software-architecture-review'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint',
      name: 'SMART goals',
      description: 'Use the SMART goals framework to keep your team on track.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1aQ3NAi0Zyg0FltAtvLcfN/e18c19b7471185512adcb1e30d12b498/smart-goals.svg',
      template: adfTemplate45,
      urlSlug: 'smart-goals'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:service-team-health-monitor-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:service-team-health-monitor-blueprint',
      name: 'Service team health monitor',
      description:
        'Understand your strengths and weaknesses as a service team and identify ways to improve.',
      icon: '//images.ctfassets.net/xjcz23wx147q/5rd8bV3YQuR5s6sN3PXput/60945bd1a3d499ad9c5064af037a3bfd/service-team-health-monitor.svg',
      template: adfTemplate46,
      urlSlug: 'service-team-health-monitor'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
      name: 'Sales portal',
      description:
        'Create a one-stop shop for all your sales information and collateral.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1ChhQESnfMkM4IEvgRCXlG/d7f0a7582302b85dcafa2a89c208d7b4/sales-portal.svg',
      template: adfTemplate47,
      urlSlug: 'sales-portal'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
      name: 'Sales account planning',
      description:
        'Develop a unique sales strategy for your accounts to close more deals.',
      icon: '//images.ctfassets.net/xjcz23wx147q/Oc74k9fuHHTeSML563pff/558c7a31f32ea33245f7ddf257144460/sales-account-planning.svg',
      template: adfTemplate48,
      urlSlug: 'sales-account-planning'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:safe-business-case-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:safe-business-case-blueprint',
      name: 'SAFe lean business case',
      description:
        'Create a lean business case for your portfolio epic based on SAFe agile practices',
      icon: '//images.ctfassets.net/xjcz23wx147q/6VGjiCkVH5q6WfFEw2aG9c/b564243a97218cd8e1d997b47900ffa2/safe-lean-business-case-new.svg',
      template: adfTemplate49,
      urlSlug: 'safe-lean-business-case'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
      name: 'Roles and responsibilities',
      description:
        'Define responsibilities for team members and identify opportunities for team growth.',
      icon: '//images.ctfassets.net/xjcz23wx147q/66FpSkvG0bXnwbnk1yJBqW/f63d9ed7d5cb2c5456d58808d8338a00/roles-_-responsibilities.svg',
      template: adfTemplate50,
      urlSlug: 'roles-and-responsibilities'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:ritual-reset-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:ritual-reset-blueprint',
      name: 'Ritual reset',
      description:
        'Use the ritual reset template to examine team processes, improve meetings, and reset team rituals.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4MpQ3grOSZ5GTEtGzTrsIe/82b18b11141e3ad08af0b270718427ab/ritual-reset.svg',
      template: adfTemplate51,
      urlSlug: 'ritual-reset'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:my-user-manual-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:my-user-manual-blueprint',
      name: 'My user manual',
      description: 'Think of it as your own personal readme.txt',
      icon: '//images.ctfassets.net/xjcz23wx147q/16jlQm8xaH1dbdAqNxFcyB/f847249f277b4598ae7d9ebcfbfed2e3/my-user-manual.svg',
      template: adfTemplate52,
      urlSlug: 'my-user-manual'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:mvp-ideation-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mvp-ideation-blueprint',
      name: 'MVP ideation',
      description: 'Work through the MVP idea with this framework.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6ed3DoB544i13i9uQuxHxp/a772874063683f35a594aa63ae78ba50/mvp-ideation.svg',
      template: adfTemplate53,
      urlSlug: 'mvp-ideation'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
      name: 'Mutual action plan',
      description:
        'Collaborate and track progress with your sales team at each stage of the deal.',
      icon: '//images.ctfassets.net/xjcz23wx147q/79XlaGinbFMvNphQaKgLtE/13c3a826c996b24e5dabc4a4b64d866a/mutual-action-plan.svg',
      template: adfTemplate54,
      urlSlug: 'mutual-action-plan'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint',
      name: 'Message house',
      description:
        'Keep your message consistent by aligning everyone with a message house.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1FugcqqiCel2z3KJTPko5K/2896f58c5b7d6e006d9656f6b95ae630/message-house.svg',
      template: adfTemplate55,
      urlSlug: 'message-house'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
      name: 'AWS architecture diagram',
      description:
        'Visualize your infrastructure to better identify weaknesses and pinpoint places for refinement.',
      icon: '//images.ctfassets.net/xjcz23wx147q/48Wzj474xufBid0gFLHItY/e8175b3a56c0b6a56063c17e8def0558/aws-architecture-diagram.svg',
      template: adfTemplate56,
      urlSlug: 'aws-architecture-diagram'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
      name: 'Meeting notes',
      description:
        'Set meeting agendas, take notes, and share action items with your team.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2WJiFysn9cisiWzy7SXdAF/69e8170aa282dbb7f922357c25de3578/meeting-notes.svg',
      template: adfTemplate57,
      urlSlug: 'meeting-notes'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:master-project-document-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:master-project-document-blueprint',
      name: 'Master project documentation',
      description:
        'Create a master project doc to give stakeholders a single source of truth for your project.',
      icon: '//images.ctfassets.net/xjcz23wx147q/7qeVkAf6Z8YQGbUTOVpzfs/ecd6311b6846840ea2f5f79d6ee61f60/master-project-documentation.svg',
      template: adfTemplate58,
      urlSlug: 'master-project-documentation'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-united-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-united-blueprint',
      name: 'Marketing united',
      description:
        'A weekly blog post from your leaders and peers is just what you need to keep everyone informed.',
      icon: '//images.ctfassets.net/xjcz23wx147q/35AiQIm6BqilPLEihcQDYM/6f4a86d6fac9eec66e024ebf68e66447/marketing-united.svg',
      template: adfTemplate59,
      urlSlug: 'marketing-united'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
      name: 'Marketing plan',
      description:
        'Define your marketing strategy and plan marketing programs with your team.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4A12rcJu3FtFBmWXfCDOB0/a15a539a2d640b12666c974092e15165/marketing-plan.svg',
      template: adfTemplate60,
      urlSlug: 'marketing-plan'
    },
  // 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint':
  //   {
  //     id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
  //     name: 'Marketing campaign',
  //     description:
  //       'Plan and track your marketing campaign tasks and deadlines through to execution.',
  //     icon: '//images.ctfassets.net/xjcz23wx147q/2nDuw6AfSTtXlbGpRdaQ9I/790d8f7fcf84f47ce2aa457bb238e12f/marketing-campaign.svg',
  //     template: require('./templates/marketing-campaign-blueprint').default
  //   },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-blueprint',
      name: 'Marketing blog post',
      description:
        'Draft your blog content, assign your reviewers, and plan your distribution strategy.',
      icon: '//images.ctfassets.net/xjcz23wx147q/271tyqHoSPMkKzCu2cdYIq/180563f0aae10f438b45002702e9d468/marketing-blog-post.svg',
      template: adfTemplate61,
      urlSlug: 'marketing-blog-post'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:leadership-team-health-monitor-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:leadership-team-health-monitor-blueprint',
      name: 'Leadership team health monitor',
      description:
        'Understand your strengths and weaknesses as a leadership team and identify ways to improve.',
      icon: '//images.ctfassets.net/xjcz23wx147q/WuOth1xiS5apOrklujANc/ac0590a27c4a0d8246e781c434180ec3/leadership-team-health-monitor.svg',
      template: adfTemplate62,
      urlSlug: 'leadership-team-health-monitor'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:job-offer-letter-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-offer-letter-blueprint',
      name: 'Job offer letter',
      description:
        'Create a offer letter to help hiring managers provide all the important employment package details for successful candidates.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1ZR4PGrvQkME9VXHQOekli/b7738e5c7c6b7937ad13fdefcb6af868/job-offer.svg',
      template: adfTemplate63,
      urlSlug: 'job-offer-letter'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-blueprint',
      name: 'Job description',
      description:
        'Use this template to build job descriptions that will attract the highest quality candidates.',
      icon: '//images.ctfassets.net/xjcz23wx147q/5F1xrcV3XVjY7aDkBEDrhR/7f302ed5f0c2912e7aca8c174a25f3ee/hiring-process.svg',
      template: adfTemplate64,
      urlSlug: 'job-description'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:it-project-poster-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:it-project-poster-blueprint',
      name: 'IT project poster',
      description:
        'Use this template to start a project that impacts many teams and/or systems.',
      icon: '//images.ctfassets.net/xjcz23wx147q/16fM36P83D4DZnAo0S9yDt/904cfbdf0533373f8984ea2c977943c7/it-project-posters.svg',
      template: adfTemplate65,
      urlSlug: 'it-project-poster'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-blueprint',
      name: 'ITSM weekly major incident report',
      description:
        'Use this template to regularly track the status of incidents and update your team on resolutions.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6XZ6UI4x9BnHZNYbgSYfZO/ff2ef2abac032e541116462b9e3087d4/ITSM-change-management.svg',
      template: adfTemplate66,
      urlSlug: 'itsm-weekly-major-incident-report'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
      name: 'ITSM runbook',
      description:
        'Use the ITSM runbook template to document the procedures for recurring ITSM alerts and outages.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6XZ6UI4x9BnHZNYbgSYfZO/ff2ef2abac032e541116462b9e3087d4/ITSM-change-management.svg',
      template: adfTemplate67,
      urlSlug: 'itsm-runbook'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-blueprint',
      name: 'ITSM post incident review',
      description:
        'Use this template to outline an incident’s causes and prevent it from recurring.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6XZ6UI4x9BnHZNYbgSYfZO/ff2ef2abac032e541116462b9e3087d4/ITSM-change-management.svg',
      template: adfTemplate68,
      urlSlug: 'itsm-post-incident-review'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
      name: 'ITSM known errors',
      description:
        'Use the ITSM known errors template to document solutions and update status information about known errors.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6XZ6UI4x9BnHZNYbgSYfZO/ff2ef2abac032e541116462b9e3087d4/ITSM-change-management.svg',
      template: adfTemplate69,
      urlSlug: 'itsm-known-errors'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint',
      name: 'ITSM change management',
      description:
        'Use this template to describe and track change management plans.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6XZ6UI4x9BnHZNYbgSYfZO/ff2ef2abac032e541116462b9e3087d4/ITSM-change-management.svg',
      template: adfTemplate70,
      urlSlug: 'itsm-change-management'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:introductory-blog-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:introductory-blog-blueprint',
      name: 'Introductory blog',
      description:
        'Create an interesting blog introducing yourself to your colleagues.',
      icon: '//images.ctfassets.net/xjcz23wx147q/O7HzERpvSchungoRezWYf/e9d2f343c8f6626eeabda5d33c27a4b8/introductory-blog.svg',
      template: adfTemplate71,
      urlSlug: 'introductory-blog'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:interview-feedback-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:interview-feedback-blueprint',
      name: 'Interview feedback',
      description:
        'Use this rubric, from Indeed.com, to improve the quality and consistency of interview feedback.',
      icon: '//images.ctfassets.net/xjcz23wx147q/5F1xrcV3XVjY7aDkBEDrhR/7f302ed5f0c2912e7aca8c174a25f3ee/hiring-process.svg',
      template: adfTemplate72,
      urlSlug: 'interview-feedback'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-blueprint',
      name: 'Incident postmortem',
      description:
        'Record an incident’s cause and impact to reduce the likelihood of future incidents.',
      icon: '//images.ctfassets.net/xjcz23wx147q/7N0uYdxOwOjyEIchJ075Rb/cec851f8e935dae8b1401e4338762bf6/incident-postmortem.svg',
      template: adfTemplate73,
      urlSlug: 'incident-postmortem'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-blueprint',
      name: 'Incident communication',
      description:
        'Use this template to create a guide for how to respond when things go wrong.',
      icon: '//images.ctfassets.net/xjcz23wx147q/dQWg9d3PVB7aPP4FN4s3a/02ee49ed275f6bad45bec9795b74a538/incident-communication.svg',
      template: adfTemplate74,
      urlSlug: 'incident-communication'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
      name: 'HR knowledge base',
      description:
        'Offer a central area for employees to access HR documents and policies.',
      icon: '//images.ctfassets.net/xjcz23wx147q/cec7HVcVualUEsI8X5Ukg/43759a11d65352fc1ad61afa8f163d77/hr-knowledge-base.svg',
      template: adfTemplate75,
      urlSlug: 'hr-knowledge-base'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
      name: 'Risk assessment matrix',
      description:
        'Identify and prioritize risks, then define what further actions you need to take to control.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1HHoHToUw0PqrMY8ucPefD/03e5834b94971f0f0892b3f81139b958/risk-assessment.svg',
      template: adfTemplate76,
      urlSlug: 'risk-assessment'
    },
  'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
      name: 'Retrospective',
      description:
        'What went well? What could have gone better? Crowdsource improvements with your team.',
      icon: '//images.ctfassets.net/xjcz23wx147q/7PB0uX3R0y3wkSR6EhpPS/8945296885c9a3a747d1a63db22d633b/retrospective.svg',
      template: adfTemplate77,
      urlSlug: 'retrospective'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-blueprint',
      name: 'Remote team meeting',
      description:
        'Organize recurring team syncs and provide your team with the latest project status updates.',
      icon: '//images.ctfassets.net/xjcz23wx147q/55tBqNsRfEOS3wnEnBiRU4/fec017c79e3ef54101663d39eec99e9e/remote-team-meeting.svg',
      template: adfTemplate78,
      urlSlug: 'remote-team-meeting'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-blueprint',
      name: 'QTC acquisition',
      description:
        'Assist the accounts receivable and revenue teams regarding quote-to-cash during an acquisition.',
      icon: '//images.ctfassets.net/xjcz23wx147q/40Wv0EM9NrxTIzsmsvJyE5/669c70cd5766231a891476a568d1f44b/safe-lean-business-case-revised.svg',
      template: adfTemplate79,
      urlSlug: 'qtc-acquisition'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:quarterly-check-in-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:quarterly-check-in-blueprint',
      name: 'Quarterly check in',
      description:
        'Reflect on your quarterly performance and growth in preparation for your review with your manager.',
      icon: '//images.ctfassets.net/xjcz23wx147q/3dHhGRXAJEr3W1hCUQypez/00befb3f67626d6ed42de0b4ba287310/quarterly-check-in.svg',
      template: adfTemplate80,
      urlSlug: 'quarterly-check-in'
    },
  'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
      name: 'How-to article',
      description: 'Provide step-by-step guidance for completing a task.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2Y5iAkWtss2AJ7m4nnguiS/496e187687d6f5fd86f822bbc09f688c/how-to-article.svg',
      template: adfTemplate81,
      urlSlug: 'how-to-article'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
      name: 'Hiring process',
      description:
        'Develop a repeatable hiring process to get everyone on the same page and make recruiting a breeze.',
      icon: '//images.ctfassets.net/xjcz23wx147q/5F1xrcV3XVjY7aDkBEDrhR/7f302ed5f0c2912e7aca8c174a25f3ee/hiring-process.svg',
      template: adfTemplate82,
      urlSlug: 'hiring-process'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:project-team-health-monitor-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-team-health-monitor-blueprint',
      name: 'Project team health monitor',
      description:
        "Evaluate your team's effectiveness and fine tune so you can focus on your deliverables.",
      icon: '//images.ctfassets.net/xjcz23wx147q/1EyiRBfikTOd4wykDf2ADk/d06c52a882abcad9ff82951ad69b7bf0/project-team-health-monitor.svg',
      template: adfTemplate83,
      urlSlug: 'project-team-health-monitor'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
      name: 'Project status',
      description:
        'Easily report progress on your projects to stakeholders using Confluence and Jira together.',
      icon: '//images.ctfassets.net/xjcz23wx147q/5KMZJEwRUKo9Mb4GV6dHGz/19b62b14a4fdc7b0171d6783d5e0666d/project-status.svg',
      template: adfTemplate84,
      urlSlug: 'project-status'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:pp-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:pp-blueprint',
      name: 'Project poster',
      description:
        'Use this template to define your problem, propose a solution and get ready to execute.',
      icon: '//images.ctfassets.net/xjcz23wx147q/445ujiEmT8oik1VhXjhzQo/911ed4a52b7a17e68693cafd9d111101/project-poster.svg',
      template: adfTemplate85,
      urlSlug: 'project-poster'
    },
  // 'com.atlassian.confluence.plugins.confluence-business-blueprints:gsm-blueprint':
  //   {
  //     id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:gsm-blueprint',
  //     name: 'Goals, signals, measures',
  //     description:
  //       "Use this template to distinguish the signal from the noise in setting your team's goals.",
  //     icon: '//images.ctfassets.net/xjcz23wx147q/hV0B8VPVxW1jZt1A7ENx6/6211580ee53e9700041ce1c4b4754859/goals-signals-measures.svg',
  //     template: require('./templates/gsm-blueprint').default
  //   },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
      name: 'Project plan',
      description: 'Define, scope, and plan milestones for your next project.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6dh7ohRu5A62L3wtwWpRX7/8bd7cb89b8134b207d9e62ff70a44125/project-plan.svg',
      template: adfTemplate86,
      urlSlug: 'project-plan'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-blueprint',
      name: 'Project kickoff',
      description:
        'Lead a project kickoff and align teams on project expectations with this template.',
      icon: '//images.ctfassets.net/xjcz23wx147q/LJvbiZJ5727erMZCTqZA4/544c26dddca95c314b50a72d390aa0b2/project-kickoff.svg',
      template: adfTemplate87,
      urlSlug: 'project-kickoff'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:fundraising-database-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:fundraising-database-blueprint',
      name: 'Fundraising database',
      description:
        'Keep track of all of your investor communications for each fundraising round.',
      icon: '//images.ctfassets.net/xjcz23wx147q/7fwCfzohnr727CFWBh3x9F/aaf5d5dec698419b448ed719ad2473bf/fundraising-database.svg',
      template: adfTemplate88,
      urlSlug: 'fundraising-database'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
      name: 'Product roadmap',
      description: 'Capture your team’s high level product roadmap.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1CfLapHrBVRHOjhjn8CAs3/5fed32ae76d97cc5dc4241ed11285973/product-roadmap.svg',
      template: adfTemplate89,
      urlSlug: 'product-roadmap'
    },
  'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
      name: 'Product requirements',
      description:
        'Define, track and scope requirements for your product or feature.',
      icon: '//images.ctfassets.net/xjcz23wx147q/p2MmqSYrdbda2OnX9pdqc/28952db6a8e44883015acb2017d0fef0/product-requirements.svg',
      template: adfTemplate90,
      urlSlug: 'product-requirements'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
      name: 'Executive business review',
      description:
        'Capture and present high level business performance to major stakeholders.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4JuQyaQsyddqlL0cnppv3B/c7007f08780c7f99c5ba6d18cd68b44f/executive-business-review.svg',
      template: adfTemplate91,
      urlSlug: 'executive-business-review'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:productlaunch-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:productlaunch-blueprint',
      name: 'Product launch',
      description:
        'Prepare your product launch, document strategy, and plan launch activities.',
      icon: '//images.ctfassets.net/xjcz23wx147q/11lqfqkR9Hdeneicu6ICJp/37644ce2a48352464f73f4de48b835e3/product-launch.svg',
      template: adfTemplate92,
      urlSlug: 'product-launch'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:problem-framing-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:problem-framing-blueprint',
      name: 'Problem framing',
      description:
        'Use this template to run a problem framing exercise and create a problem statement.',
      icon: '//images.ctfassets.net/xjcz23wx147q/71wdrAezbbextMS4K4arG3/1d0ae139971a8882fd3e7656e81c2551/problem-framing.svg',
      template: adfTemplate93,
      urlSlug: 'problem-framing'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:prioritization-matrix-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:prioritization-matrix-blueprint',
      name: 'Prioritization matrix',
      description:
        'Compile your team’s priorities so that everyone is on the same page.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4gd3sOHBAuUfUxj0pkgS3A/ef35ff155f2d01705249d7d31fd46eaa/prioritization-matrix.svg',
      template: adfTemplate94,
      urlSlug: 'prioritization-matrix'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:experiment-planning-and-results-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:experiment-planning-and-results-blueprint',
      name: 'Experiment plan and results',
      description:
        'Document the details of your experiment including your hypothesis, variations, and results.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2Fmw1CaY6RrB4wdPfQzpLM/9920865208098a1f96d0846965ef3f9c/experiment-plan-and-results.svg',
      template: adfTemplate95,
      urlSlug: 'experiment-plan-and-results'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
      name: 'End of week status report',
      description:
        'Let team members share how things are going at the end of the week.',
      icon: '//images.ctfassets.net/xjcz23wx147q/13amOL1sEeRnEFduQV1vSa/8fbb27b8de8d2e7888bdea55a7cd5f69/end-of-week-status-report.svg',
      template: adfTemplate96,
      urlSlug: 'end-of-week-status-report'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-promotion-letter-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-promotion-letter-blueprint',
      name: 'Employee promotion letter',
      description:
        'Create a formal promotion letter to congratulate your employee.',
      icon: '//images.ctfassets.net/xjcz23wx147q/6Fthd3F332nKG47osNWhVN/a24af06ae43562d372707aef8b946a36/employee-promotion-letter.svg',
      template: adfTemplate97,
      urlSlug: 'employee-promotion-letter'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
      name: 'Employee handbook',
      description:
        'Create an employee handbook by using our template to design a table of contents and convey company information.',
      icon: '//images.ctfassets.net/xjcz23wx147q/rZQi2FO6vqJUVNY6xNsL3/2b4e4855bbb2737176a246a861ebdb13/employee-handbook.svg',
      template: adfTemplate98,
      urlSlug: 'employee-handbook'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:email-drip-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:email-drip-blueprint',
      name: 'Email drip campaign',
      description:
        'Keep the details of your email sends organized and the results clear for your team',
      icon: '//images.ctfassets.net/xjcz23wx147q/56OHCZY581pCGcUzy4gg9n/3c76638dbe10f6461b6eb3744358d657/email-drip.svg',
      template: adfTemplate99,
      urlSlug: 'email-drip'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:elevator-pitch-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:elevator-pitch-blueprint',
      name: 'Elevator pitch',
      description:
        'Use this template to create an elevator pitch that communicates the value of a project.',
      icon: '//images.ctfassets.net/xjcz23wx147q/2BsNTQdfdoM2T0AersIIwK/f3f753f7c929c2119f2bc15da0ccafd6/elevator-pitch.svg',
      template: adfTemplate100,
      urlSlug: 'elevator-pitch'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-blueprint',
      name: 'Disruptive brainstorming',
      description:
        'Use the disruptive brainstorming technique and template to generate fresh ideas with your team.',
      icon: '//images.ctfassets.net/xjcz23wx147q/7yuw3oWnDYVYhsR8SBdToM/3bc2f7587b410b9af6e44903e003a479/Disruptive_Brainstorming.png',
      template: adfTemplate101,
      urlSlug: 'disruptive-brainstorming'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-change-management-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-change-management-blueprint',
      name: 'DevOps change management',
      description:
        'Use this template to assess your change management performance and mitigate risk.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4Rg6dwIu0A1Okt99iIxNpv/09a426606e2e5fcb7b4c4a53ca46150d/devops-change-management.svg',
      template: adfTemplate102,
      urlSlug: 'devops-change-management'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
      name: 'DevOps runbook',
      description:
        'Prepare your operations team to quickly respond to system alerts and outages.',
      icon: '//images.ctfassets.net/xjcz23wx147q/5yOTXUyEJXL0SLRQm0zhlo/047094bb8b9e5ecfa9682e5265bd95a8/devops-runbook.svg',
      template: adfTemplate103,
      urlSlug: 'devops-runbook'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint',
      name: 'Presenter mode',
      description:
        'Quickly create a killer presentation on Confluence by using the presenter mode template.',
      icon: '//images.ctfassets.net/xjcz23wx147q/5ar7KO6lQ7DnsuxTY3YO5p/692fbb81dd05c0ea874748bcfbeffb71/presenter-mode.svg',
      template: adfTemplate104,
      urlSlug: 'presenter-mode'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:pre-mortem-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:pre-mortem-blueprint',
      name: 'Premortem',
      description:
        'Use this template to run a pre-mortem session for your team to identify and plan for risks.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4yCrw6Xnrfx8aTgIUlevQM/70ad4b22938c26481eef9f7691e0785d/premortem.svg',
      template: adfTemplate105,
      urlSlug: 'premortem'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
      name: 'Persona',
      description:
        'Create personas to represent different user types of your product or service.',
      icon: '//images.ctfassets.net/xjcz23wx147q/EgBsyRaA3xghzzQpK1Eda/fa8b90adb0413dac02523700a3f44585/persona.svg',
      template: adfTemplate106,
      urlSlug: 'persona'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:performance-improvement-plan-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:performance-improvement-plan-blueprint',
      name: 'Performance improvement plan',
      description:
        'Create a performance improvement plan to give employees a chance to address performance problems.',
      icon: '//images.ctfassets.net/xjcz23wx147q/7au9useomFaQrPZ59udnPM/b4d9368dad58c88b550138ad7fc0ed68/performance-improvement-plan.svg',
      template: adfTemplate107,
      urlSlug: 'performance-improvement-plan'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:ooo-team-notification-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:ooo-team-notification-blueprint',
      name: 'OOO team notification',
      description:
        'Provide a place for your team members to report their out-of-office (OOO) information. ',
      icon: '//images.ctfassets.net/xjcz23wx147q/z4Aid1mj5HPpCRMk47WlU/4f39ab8b86b2802340b5e7fa323189d8/ooo-team-notification.svg',
      template: adfTemplate108,
      urlSlug: 'ooo-team-notification'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
      name: '90-day plan',
      description:
        'Create a 90-day plan to help new hires get up to speed and succeed in their new role.',
      icon: '//images.ctfassets.net/xjcz23wx147q/4gylgtLLnXF4P67O9raYJU/f84f24ab0d7b6dad8937e172b938806a/90-day-plan.svg',
      template: adfTemplate109,
      urlSlug: '90-day-plan'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
      name: 'DACI: Decision documentation',
      description:
        'Use this template to effectively guide your team in making informed group-decisions',
      icon: '//images.ctfassets.net/xjcz23wx147q/SrleAf1AbF5ZICDejF6V8/02b190c9df13d0dc6db39a6c22d90372/DACI_Icon.svg',
      template: adfTemplate110,
      urlSlug: 'decision'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:4-ls-retrospective-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:4-ls-retrospective-blueprint',
      name: '4Ls retrospective',
      description:
        'Use this template to conduct a 4Ls retrospective with your team.',
      icon: '//images.ctfassets.net/xjcz23wx147q/3mQwck0AMkvTR9OWmbRZ13/62ec77b3a1688d2120c1e98e0eaf9470/4-ls-retrospective.svg',
      template: adfTemplate111,
      urlSlug: '4-ls-retrospective'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint',
      name: '1-on-1 meeting',
      description:
        'Run 1-on-1 meetings and maintain productive working relationships.',
      icon: '//images.ctfassets.net/xjcz23wx147q/3YE5hYROMhaDqvw3l9aTGf/3d99e70c9276a0cfe72b5158af76f91c/MeeticalLogo.webp',
      template: adfTemplate112,
      urlSlug: '1-on-1-meeting'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
      name: 'Annual plan one-pager',
      description:
        "Share your company's annual plans and priorities across your entire organization.",
      icon: '//images.ctfassets.net/xjcz23wx147q/XOKonBU1uNtJbxt4u28IP/0ba9a21ffca88bf8fd5eda9f9e5f0dd5/annual-plan-one-pager.svg',
      template: adfTemplate113,
      urlSlug: 'annual-plan-one-pager'
    },
  'com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-blueprint':
    {
      id: 'com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-blueprint',
      name: '5 whys analysis template',
      description:
        'Use this template to conduct a 5 whys analysis and discover the sources of team problems.',
      icon: '//images.ctfassets.net/xjcz23wx147q/1ncifTWfDmcZ1pdAIkbc2e/306280569ebff4437e330291b33cbe78/5-whys-analysis.svg',
      template: adfTemplate114,
      urlSlug: '5-whys-analysis'
    }
};
